import React from 'react';

export const IconHistory: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="20" height="20" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <path fill="currentColor" d="M20,2C10.06,2,2,10.06,2,20s8.06,18,18,18,18-8.06,18-18S29.94,2,20,2ZM20,36c-8.82,0-16-7.18-16-16S11.18,4,20,4s16,7.18,16,16-7.18,16-16,16Z" />
        <polygon fill="currentColor" points="20 21 20 8 18 8 18 21 18 23 32 23 32 21 20 21" />
    </svg>
);
